<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">Jimmy Campbell</p>
<p class="noindent">Carolyn Chisam</p>
<p class="noindent">Geraldine Eppley</p>
<p class="noindent">Darrell and Tonya Farmer</p>
<p class="noindent">Natasha Hipp</p>
<p class="noindent">Gavin Howard</p>
<p class="noindent">Ralph Howard</p>
<p class="noindent">Jimmy and Jagina Howard King</p>
<p class="noindent">Hilda Howard Morrow</p>
<p class="noindent">Charlie Wilson</p>
<p class="noindent">Richard H. Wood</p>
<p class="noindent">Alan Zordan</p>
<p class="noindent1">A special word of thanks to Candace Rathbone for her tireless work and expert assistance in preparing the manuscript for publication.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?4a4ea8fe